<div class="flex items-center justify-center bg-gray-100">
  <div class="w-full bg-white rounded-lg shadow-l p-3 md:p-8 space-y-6">

    <div class="flex items-center justify-between mb-8">
      <h1 class="text-xl font-bold">Documenti SGI</h1>
    </div>

    <app-search-panel [searchFields]="searchPanelConfig" (searchParamChange)="onSearchParamChange($event)"></app-search-panel>

  @if(documents$ | async; as documents) {
    <div class=" overflow-auto w-full cursor-pointer">
      <div class="md:shadow-lg md:bg-gray-50 md:border md:border-gray-200 rounded-xl">
        <div class="mx-auto">

          <table class="w-full border-collapse block md:table ">

            <thead class="block md:table-header-group">
            <tr class="absolute -top-full -left-full md:relative md:top-auto md:left-auto md:table-row block border-b border-gray-200 bg-gray-100/50">
              <th class="p-4 text-left text-xs font-bold text-gray-500 uppercase md:table-cell"><div class="table-header-row" (click)="setOrder('id')">ID
                @if(currentSort.field === 'id') {
                  <span>{{ currentSort.order === 'asc' ? '&#9650;' : '&#9660;'}}</span>
                }
              </div></th>
              <th class="p-4 text-left text-xs font-bold text-gray-500 uppercase md:table-cell">
                <div class="table-header-row" (click)="setOrder('label')">Nome
                  @if(currentSort.field === 'label') {
                    <span>{{ currentSort.order === 'asc' ? '&#9650;' : '&#9660;'}}</span>
                  }
                </div>
              </th>
              <th class="p-4 text-left text-xs font-bold text-gray-500 uppercase md:table-cell"><div class="table-header-row" (click)="setOrder('department_id')">Tipo
              @if(currentSort.field === 'department_id') {
                <span>{{ currentSort.order === 'asc' ? '&#9650;' : '&#9660;'}}</span>
              }
            </div></th>
              <th class="p-4 text-left text-xs font-bold text-gray-500 uppercase md:table-cell"><div class="table-header-row" (click)="setOrder('registration_date')">Data Registrazione
                @if(currentSort.field === 'registration_date') {
                  <span>{{ currentSort.order === 'asc' ? '&#9650;' : '&#9660;'}}</span>
                }
              </div></th>

            </tr>
            </thead>

            <tbody class="block md:table-row-group">
              @for (r of documents; track r.id) {
                <tr (click)="onRowClicked(r.id)"
                    class="bg-white block md:table-row mb-4 md:mb-0 rounded-2xl md:rounded-none border border-gray-100 md:border-b md:border-gray-200 shadow-sm md:shadow-none hover:bg-blue-50/30 transition-colors">

                  <div class="flex flex-col p-5 md:p-0 md:contents">

                    <div class="flex flex-col gap-3 md:contents">
                      <div class="flex justify-between items-start md:contents">

                        <td class="p-0 md:p-4 block md:table-cell text-sm font-mono text-gray-400 md:text-gray-900">
                          #{{ r.id }}
                        </td>

                      </div> <td class="p-0 md:p-4 md:pt-4 block md:table-cell text-lg md:text-sm font-bold md:font-medium text-gray-800">
                      {{ r.label }}
                    </td>
                    </div> <div class="flex justify-between items-end mt-5 pt-4 border-t border-gray-50 md:contents md:mt-0 md:pt-0 md:border-t-0">

                    <div class="flex flex-col md:contents">
                      <td class="p-0 md:p-4 md:pl-4 block md:table-cell text-sm text-gray-600 font-medium md:font-normal">
                        <span class="inline-block font-bold uppercase text-[10px] md:hidden text-gray-400">Codice</span><br class="md:hidden">
                        {{ r.department_id.label }}
                      </td>
                    </div>

                    <div class="flex flex-col text-right md:contents md:text-left">
                      <td class="p-0 md:p-4 block md:table-cell text-sm text-gray-600 italic md:not-italic font-medium md:font-normal">
                        <span class="inline-block font-bold uppercase text-[10px] md:hidden text-gray-400">Data</span><br class="md:hidden">
                        {{ r.registration_date }}
                      </td>
                    </div>

                  </div> </div> </tr>
              } @empty {
                <div class="flex justify-center items-center h-24">
                  <h4 class="text-center absolute w-[300px] left-1/2 -translate-x-1/2">Nessun record trovato</h4>
                </div>
              }
            </tbody>
          </table>

        </div>
      </div>

      <app-pagination [params]="pagingParams" [totalItems]="totalRows" (pageChange)="goToPage($event)"></app-pagination>
    </div>
  }
    <div class="flex items-center justify-end mb-8">
      <button (click)="refresh()" class="button primary">
        <img class="inline align-sub" ngSrc="/icons/refresh.svg" alt="" height="20" width="20">
        Aggiorna Elenco
      </button>
    </div>



    <div class="document-preview">
      <div class="dimmer" (click)="closePreview()"></div>
      <div class="preview-content">
        <iframe #iframe class="iframe"></iframe>
      </div>
    </div>
  </div>
</div>
